// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tips-iIG9rtpB {\n    font-size: 26px;\n    color: #999;\n    letter-spacing: 0;\n    text-align: justify;\n    padding: 20px 0;\n}\n", ""]);
// Exports
exports.locals = {
	"tips": "tips-iIG9rtpB"
};
module.exports = exports;
